function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3599A5;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#25426A;}\r\n\t@keyframes example {\r\n\t\t  0%{fill:#FFFFFF;}\r\n\t\t 50%{fill:#25426A;}\r\n\t\t100%{fill:#FFFFFF;}\r\n\t}\r\n\t#Layer_1 .st1{\r\n\t\tanimation: example 3s infinite;\r\n\t\tanimation-timing-function: ease-in-out;\r\n\t}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 40,
  cy: 40,
  r: 40
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M40.96,50.79c0.24,0.15,0.48,0.29,0.74,0.38c0.31,0.11,0.63,0.16,0.94,0.1c0.4-0.08,0.86-0.37,1.19-0.61 c0.52-0.39,1.04-0.85,1.5-1.31c0.15-0.15,0.31-0.32,0.46-0.47c0.48-0.5,0.98-1.02,1.66-1.23c0.64-0.21,1.25-0.08,1.84,0.22 l9.45,4.82c0.26,0.13,0.47,0.34,0.59,0.62c0.13,0.32,0.12,0.67,0.05,1.01c-0.3,1.33-0.79,2.64-1.56,3.77 c-1.15,1.66-2.76,2.71-4.71,3.18c-2.07,0.5-4.34,0.32-6.4-0.14c-3.6-0.81-7.2-2.57-10.23-4.65c-1.31-0.9-2.55-1.97-3.71-3.06 c-1.36-1.28-2.67-2.66-3.86-4.1c-1.2-1.45-2.31-2.98-3.33-4.55c-0.85-1.33-1.67-2.75-2.32-4.2c-1.49-3.37-2.56-7.23-2.69-10.92 c-0.07-2.11,0.16-4.37,1.04-6.32c0.82-1.83,2.16-3.22,3.99-4.03c1.26-0.57,2.64-0.8,4-0.85c0.34-0.01,0.68,0.04,0.96,0.22 c0.26,0.16,0.42,0.41,0.5,0.7l3,10.18c0.19,0.63,0.19,1.26-0.12,1.85c-0.34,0.63-0.93,1.02-1.52,1.39 c-0.19,0.12-0.37,0.25-0.54,0.38c-0.54,0.37-1.09,0.78-1.56,1.23c-0.3,0.28-0.67,0.67-0.82,1.05c-0.12,0.31-0.13,0.63-0.08,0.95 c0.06,0.33,0.19,0.67,0.32,0.97c0.45,1.04,1.2,2.17,1.86,3.09c0.96,1.4,2.01,2.74,3.09,4.04c1.09,1.3,2.22,2.58,3.41,3.8 c0.8,0.81,1.75,1.74,2.7,2.38L40.96,50.79z"
});

var SvgNavIconWhite = function SvgNavIconWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavIconWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-icon-white.5d572d93.svg";
export { ForwardRef as ReactComponent };